import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { TypeVehicle, TypeVehicleType } from "../../types/slices/typeVehicleType";

const initialState: TypeVehicleType = {
    status: ApiStatus.FETCHED,
    typeVehicles: [],
    errorMessage: undefined,
    editTypeVehicle: {} as TypeVehicle,
    selectedTypeVehicle: {} as TypeVehicle,
};

const typeVehicleSlice = createSlice({
    name: "typeVehicle",
    initialState,
    reducers: {
        onFetchTypeVehicle(state, { payload }: { payload: TypeVehicle[] }) {
            state.status = ApiStatus.FETCHED;
            state.typeVehicles = payload;
            state.errorMessage = undefined;
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload;
        },
        onSetEditTypeVehicle(state, { payload }: { payload: TypeVehicle }) {
            state.editTypeVehicle = payload;
        },
        onSetSelectedTypeVehicle(state, { payload }: { payload: TypeVehicle }) {
            state.selectedTypeVehicle = payload;
        },
    }
});

export const selectTypeVehicleState = (state: RootState) => state.typeVehicleSlice;
export default typeVehicleSlice.reducer;

export const {
    onFetchTypeVehicle,
    changeStatus,
    onSetEditTypeVehicle,
    onSetSelectedTypeVehicle,
} = typeVehicleSlice.actions